import {
	Box,
	Image,
	HStack,
	Text,
	Center,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	VStack,
	Link,
} from "@chakra-ui/react";
import { ICON_TYPE } from "../../../configs/constants/IconsTypes";
import { t } from "i18next";
import { useState } from "react";
import Button from "../../Core/Button/Button";

interface Props {
	fileName: string;
	fileUrl: string;
	onRemove?: (url: string) => void;
}

const FileThumbnail = ({ fileName, fileUrl, onRemove }: Props) => {
	const [deleteConfirmModalVisible, setDeleteConfirmModalVisible] = useState<boolean>(false);

	return (
		<Box
			w="fit-content"
			bg={"#FFF"}
			border={"1px solid #E6E6E6"}
			px={2}
			py={2}
			borderRadius={"10px"}
		>
			<HStack fontSize={"14px"} fontWeight={400} color={"#4E7EA7"}>
				{fileUrl.endsWith(".jpg") || fileUrl.endsWith(".png") || fileUrl.endsWith(".jpeg") ? (
					<Image
						src={fileUrl}
						alt={`Thumbnail ${fileName}`}
						width={35}
						height={35}
						objectFit={"cover"}
						borderRadius={"4px"}
					/>
				) : fileUrl.endsWith(".pdf") ? (
					<embed src={fileUrl} width="35" height="35" />
				) : (
					<Text>{fileName}</Text>
				)}
				<Link href={fileUrl} isExternal>
					<Text>{fileName}</Text>
				</Link>
				{onRemove && (
					<Center
						borderRadius={"full"}
						p={1}
						bg={"#999999"}
						cursor={"pointer"}
						ml={2}
						onClick={() => setDeleteConfirmModalVisible(true)}
						_hover={{ opacity: 0.5 }}
					>
						<img height={"6px"} width={"6px"} alt={"remove-icon"} src={ICON_TYPE.REMOVE_ICON} />
					</Center>
				)}
			</HStack>

			<Modal
				size={"xl"}
				isOpen={deleteConfirmModalVisible}
				onClose={() => setDeleteConfirmModalVisible(false)}
			>
				<ModalOverlay />
				<ModalContent p={4}>
					<ModalHeader textAlign="center">{t("DELETE_DOCUMENT")}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Text align={"center"}>{`${t("DELETE_DOCUMENT_TEXT")} ${fileName} ?`}</Text>
					</ModalBody>
					<VStack>
						<Button
							onClick={() => {
								onRemove && onRemove(fileUrl);
								setDeleteConfirmModalVisible(false);
							}}
							width="220px"
							margin="2.5rem 0 0 0"
							fontSize="s"
							height="34px"
						>
							{t("YES")}
						</Button>
						<Button
							onClick={() => setDeleteConfirmModalVisible(false)}
							width="220px"
							margin="0.625rem 0 0 0"
							textColor="black"
							backgroundColor="buttonGray"
							fontSize="s"
							height="34px"
						>
							{t("NO")}
						</Button>
					</VStack>
				</ModalContent>
			</Modal>
		</Box>
	);
};

export default FileThumbnail;
